import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a3d1221c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" faceScale: 얼굴 크기 비율 조정값, 100%로부터의 차이 ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" faceOffsetX: 얼굴의 가로 방향 이동 정도 ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" faceOffsetY: 얼굴의 세로 방향 이동 정도 ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" maskBlur: 얼굴 마스크를 흐릿하게 할 범위 ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" maskErode: 얼굴 마스크를 깎을 범위. ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" superResolution: 화질 개선 정도. 0이 아닌 값을 설정하면 작업시간이 조금 더 오래 걸릴 수 있습니다. ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_typography_title = _resolveComponent("a-typography-title")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_MediaCards = _resolveComponent("MediaCards")!
  const _component_table_list = _resolveComponent("table-list")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_MediaCards, {
      ref: "mediaCardRef",
      type: [
      { name: 'video', props: { search: true, min: 1 } },
      // { name: 'ImageMappingCard', props: { search: false, min: 1 } },
      {
        name: 'ControlCard',
        props: {
          disabled: false,
        },
        event: {
          sub: _ctx.onClick,
        },
      },
    ]
    }, {
      guide: _withCtx(() => [
        _createVNode(_component_a_typography_title, { level: 5 }, {
          default: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1
        }),
        _createVNode(_component_a_typography_title, { level: 5 }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }),
        _createVNode(_component_a_typography_title, { level: 5 }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }),
        _createVNode(_component_a_typography_title, { level: 5 }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }),
        _createVNode(_component_a_typography_title, { level: 5 }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }),
        _createVNode(_component_a_typography_title, { level: 5 }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        })
      ]),
      scenariooption: _withCtx(() => [
        _createVNode(_component_a_input, {
          value: _ctx.text,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.text) = $event)),
          placeholder: "원하는 키워드"
        }, null, 8, ["value"])
      ]),
      _: 1
    }, 8, ["type"]),
    _createVNode(_component_table_list, {
      ref: "tableListRef",
      columns: _ctx.columns,
      "list-columns": [
      {
        title: '만든사람',
        key: 'username',
      },
    ],
      apis: { list: _ctx.apiUrl },
      type: "image",
      "table-handler-props": { mode: ['download'] }
    }, null, 8, ["columns", "apis"])
  ], 64))
}